import { extendTheme } from '@chakra-ui/react';

const hideFocus = ({
	baseStyle: {
		_focus: {
			'&:not(:focus-visible)': {
				boxShadow: 'none'
			}
		}
	}
})

const config = {
	initialColorMode: 'gray.50',
	useSystemColorMode: true
}

export default extendTheme({
	fonts: {
		body: `'Glory', sans-serif`,
		heading: `'Lexend', sans-serif`,
	},
	components: {
		Button: hideFocus,
		Link: hideFocus
	},
	config
});